import React from 'react';
import { graphql } from 'gatsby';
import { StaffProfileFeed as StaffProfileFeedComponent } from '../../StaffProfileFeed';

export const StaffProfileFeed = ({ data, ...rest }) => <StaffProfileFeedComponent {...data} {...rest} />;

export const StaffProfileFeedQuery = graphql`
  fragment StaffProfileFeed on KFH_UmbracoStaffProfileFeedComponentType {
    title
    action
    backgroundColour
    division {
      name
      divisionStaffs {
        staff {
          fullName
          position
          bio
          email
          directDialNumber
          keyResponsibilities
          position
          profile
          startDate
          mediaSet {
            media {
              role
              media {
                localFile {
                  gatsbyImage(
                    width: 452
                    height: 340
                    layout: CONSTRAINED
                    placeholder: NONE
                    quality: 80
                    backgroundColor: "#F5F5F5"
                  )
                }
              }
            }
          }
        }
      }
    }
  }
`;
